import type { FormSnippet } from '@ipfabric/ui-components/utils/formSnippets/FormSnippet';
import { generateGuid } from 'utils/guid';
import z from 'zod';
import {
  type CustomDiscoveryDefinitionRow,
  customDiscoveryDefinitionsSchema,
} from '../components/CustomDiscoveryDefinitions/CustomDiscoveryDefinitionRow';
import { CustomDiscoveryDefinitions } from '../components/CustomDiscoveryDefinitions/CustomDiscoveryDefinitions';
import type { DiscoverySettingsObject } from '../model/DiscoverySettingsObject';

type CustomDiscoveryDefinitionsFieldValues = {
  customDiscoveryDefinitions: CustomDiscoveryDefinitionRow[];
};

export const customDiscoveryDefinitions: FormSnippet<
  DiscoverySettingsObject,
  CustomDiscoveryDefinitionsFieldValues
> = {
  render: ({ form }) => <CustomDiscoveryDefinitions form={form} />,
  fromModel: (model, fieldValuesDraft) => {
    fieldValuesDraft.customDiscoveryDefinitions =
      model.customDiscoveryDefinitions?.map((definition) => ({
        id: definition.id ?? generateGuid(),
        enabled: definition.enabled,
        yaml: definition.yaml,
      })) ?? [];
  },
  toModel: (transformedValues, modelDraft) => {
    modelDraft.customDiscoveryDefinitions =
      transformedValues.customDiscoveryDefinitions.map(
        ({ id, enabled, yaml }) => ({ id, enabled, yaml }),
      );
  },
  schema: z.object({
    customDiscoveryDefinitions: customDiscoveryDefinitionsSchema,
  }) as z.Schema<CustomDiscoveryDefinitionsFieldValues>,
};
